import { WindowStyle } from '@barthauer/abc/ui-components';

export class ComponentRegistryEntry {
  public component: any; //unknown
  public windowStyle?: WindowStyle;

  constructor(component: any, windowStyle?: WindowStyle) {
    this.component = component;
    this.windowStyle = windowStyle;
  }
}

export const ComponentRegister: Map<string, ComponentRegistryEntry> = new Map();

export function ComponentRegistry(key: string, windowStyle?: WindowStyle): any {
  return (cls: any) => {
    const componentRegistryEntry: ComponentRegistryEntry = new ComponentRegistryEntry(cls, windowStyle);

    ComponentRegister.set(key, componentRegistryEntry);
  };
}
